import dayjs from 'dayjs';
import { MoveEventHighlightProps } from './utils.types';

export const moveEventHighlight = ({
  pendingRestoreEventId,
  force,
  position,
  event,
  calendarEvents,
  timeStep,
  setEvent
}: MoveEventHighlightProps) => {
  if (!position) return;

  const currentCalendarEvents = calendarEvents[position.calendarId || -1] || [];

  const selectedPeriodStart = position.date;
  const selectedPeriodEnd = position.date.add(timeStep, 'minutes');

  const overlappingEvents = currentCalendarEvents
    .filter(
      ({ start, end }) =>
        selectedPeriodStart?.isBefore(end) && selectedPeriodEnd?.isAfter(start)
    )
    .sort((a, b) => {
      const startDiff = dayjs(b.start).diff(a.start);
      if (startDiff !== 0) return startDiff;
      return dayjs(b.end).diff(a.end);
    });

  // if the highlight is moved as a result of moving the
  // cell-position, we only update the selected event if
  // the previous event is no longer overlapping.
  if (
    !force &&
    !!event &&
    overlappingEvents.findIndex((e) => e.id === event.id) !== -1
  )
    return;

  if (overlappingEvents.length === 0) {
    setEvent(undefined); // sanity
    return;
  }

  if (
    pendingRestoreEventId &&
    !overlappingEvents.find((e) => e.id === pendingRestoreEventId)
  ) {
    return;
  }

  const currentEventId = event?.id ?? pendingRestoreEventId;
  const currentIndex = currentEventId
    ? overlappingEvents.findIndex((e) => e.id === currentEventId)
    : -1;

  const nextIndex = currentIndex === -1 ? 0 : currentIndex + 1;
  const newIndex = nextIndex === overlappingEvents.length ? 0 : nextIndex;

  setEvent(overlappingEvents[newIndex]);
};
